
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from "../login-controlador";
    import { Email } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {
        get Controlador() { return Model; }

        Listo: boolean = false;
        mounted()
        {
            setTimeout( () => this.Listo = true, 1000 );
        }

        public async Aceptar()
        {
            this.Controlador.ModificarTipo( 'inicio' );
        }

    }
